// The hand-written Supabase `Database` type this repo ships collapses
// `.update()`/`.insert()`/`.upsert()` call params to `never` (repo pitfall,
// see the implementer-contract's global-constraints note: "cast
// (supabase.from('t') as any)"). Every write in the settlement/rates/
// listings/reviews/verification/iCal data modules goes through this one
// helper rather than repeating the cast inline, so the necessary `any`
// escape hatch (eslint.config.js scopes `no-explicit-any: off` to this file
// alone) is reviewed once instead of scattered across the data layer.
import type { SupabaseClient } from '@supabase/supabase-js';

export function writableTable(supabase: SupabaseClient, table: string): any {
  return supabase.from(table);
}
